const check = {
  state: {
    areaStore: null,
    dicStatus: null,
    dicQuery: null,
    basicStore: null,
    userAllStore: null
  },
  getters: {
    dicStatus: state => state.dicStatus,
  },
  actions: {
  },
  mutations: {
    SET_AREA_STORE: (state, value) => {
      state.areaStore = value
    },
    SET_DIC_STATUS: (state, value) => {
      console.log(value,'我是沙')
      state.dicStatus = value
    },
    SET_DIC_QUERY: (state, value) => {
      state.dicQuery = value
    },
    SET_BASIC_STORE: (state, value) => {
      state.basicStore = value
    },
    SET_USERAll_STORE: (state, value) => {
      state.userAllStore = value
    }
  }
}
export default check



// WEBPACK FOOTER //
// ./src/store/modules/check.js